/* Millo Gang — tema de Shopify (Nira, v1.0). Sin librerías.
   Bolsa con la API AJAX de Shopify, compra rápida, ficha, zoom, lookbook, intro, carnet de miembro y club.
   Los textos que vienen de la tienda se escapan con esc() antes de pintarlos. */
(function(){
  var MG = window.MG || {};
  var mgThemeEn = /^en(?:-|$)/i.test(document.documentElement.lang || '');
  var R = MG.routes || {};
  function $(s, r){ return (r||document).querySelector(s); }
  function $$(s, r){ return [].slice.call((r||document).querySelectorAll(s)); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]}); }
  function ss(k, v){ try{ if(v===undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); }catch(e){ return null; } }

  /* ── dinero con el formato de la tienda ── */
  function money(cents){
    cents = Math.round(Number(cents)||0);
    if(MG.currency && MG.shopCurrency && MG.currency !== MG.shopCurrency && window.Intl){
      try { return new Intl.NumberFormat(MG.locale || 'es', {style:'currency', currency: MG.currency, minimumFractionDigits: 2}).format(cents/100); } catch(e){}
    }
    var fmt = MG.moneyFormat || '${{amount}}';
    function d(n, p, t, s){ p = p==null?2:p; t = t||','; s = s||'.'; var x=(n/100).toFixed(p).split('.'); x[0]=x[0].replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1'+t); return x[1]?x[0]+s+x[1]:x[0]; }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if(k==='amount') return d(cents,2);
      if(k==='amount_no_decimals') return d(cents,0);
      if(k==='amount_with_comma_separator') return d(cents,2,'.',',');
      if(k==='amount_no_decimals_with_comma_separator') return d(cents,0,'.',',');
      if(k==='amount_with_apostrophe_separator') return d(cents,2,"'",'.');
      return d(cents,2);
    });
  }
  MG.money = money;

  /* ── barra: oscura sobre la portada, clara al bajar ──
     Translúcida solo arriba del todo; en cuanto se baja, negra opaca (mgn-scrolled): así el titular, el botón y las
     miniaturas de la portada no se ven a través de TIENDA, CLUB y el logo (QA r3, 12-10-2026). */
  var hd = $('.hd');
  if(hd && document.body.hasAttribute('data-dark')){
    var onS = function(){ var y = window.scrollY, solid = y > window.innerHeight*0.85; hd.classList.toggle('dark', !solid); hd.classList.toggle('light', solid); hd.classList.toggle('mgn-scrolled', y > 0); };
    window.addEventListener('scroll', onS, {passive:true}); onS();
  }
  var burger = $('.burger'), mnav = $('.mnav');
  if(burger && mnav) burger.addEventListener('click', function(){ var on = mnav.classList.toggle('on'); burger.setAttribute('aria-expanded', on); });

  /* ── intro con el logo, una vez por visita ── */
  var intro = $('.intro');
  if(intro){
    if(ss('mg_intro')==='1'){ intro.remove(); }
    else { ss('mg_intro','1'); setTimeout(function(){ intro.classList.add('out'); setTimeout(function(){ intro.remove(); }, 900); }, 1500); }
  }

  /* ── aparición al hacer scroll ── */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target); } }); }, {threshold:.12});
    var vh0 = window.innerHeight || document.documentElement.clientHeight;
    $$('.rv').forEach(function(el){ var r = el.getBoundingClientRect(); if(r.top < vh0 && r.bottom > 0) el.classList.add('on'); else io.observe(el); });
    document.documentElement.classList.add('mg-rv');
  } else { $$('.rv').forEach(function(el){ el.classList.add('on'); }); }

  /* ── lookbook: avanza en horizontal al bajar (escritorio) ── */
  $$('.lb').forEach(function(lb){
    var rail = $('.rail', lb), bar = $('.bar i', lb), stick = $('.stick', lb);
    if(!rail) return;
    function size(){
      if(window.innerWidth < 980){ lb.style.height = ''; rail.style.transform = ''; stick.style.position='relative'; stick.style.height='auto'; stick.style.padding='70px 0'; rail.style.overflowX='auto'; return; }
      stick.style.position=''; stick.style.height=''; stick.style.padding=''; rail.style.overflowX='';
      var extra = Math.max(0, rail.scrollWidth - window.innerWidth);
      lb.style.height = (window.innerHeight + extra/1.6) + 'px';
      lb._extra = extra; move();
    }
    function move(){
      if(window.innerWidth < 980 || !lb._extra) return;
      var top = lb.getBoundingClientRect().top, p = Math.min(1, Math.max(0, -top / (lb._extra/1.6)));
      rail.style.transform = 'translate3d(' + (-p*lb._extra) + 'px,0,0)';
      if(bar) bar.style.width = (p*100) + '%';
    }
    window.addEventListener('resize', size); window.addEventListener('scroll', move, {passive:true});
    window.addEventListener('load', size); size();
  });

  /* ── bolsa: ventana de diálogo. Al abrirse se lleva el foco dentro y no lo suelta (Tab da la vuelta);
     al cerrarse (Esc, la X o el velo) lo devuelve al botón que la abrió: «Añadir a la bolsa», «Bolsa»…
     Cerrada es inert: el teclado no entra en ella aunque esté en la página. ── */
  var bag = $('.bag'), veil = $('.veil'), bagBack = null, lastHit = null;
  function shown(el){ return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function bagFocusables(){ return $$('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', bag).filter(shown); }
  if(bag){
    bag.setAttribute('role', 'dialog'); bag.setAttribute('aria-modal', 'true'); bag.setAttribute('tabindex', '-1');
    if(!bag.classList.contains('on')) bag.inert = true;
  }
  /* quién abre la bolsa: el último botón o enlace pulsado fuera de ella (al añadir, el botón se desactiva y pierde el foco) */
  document.addEventListener('click', function(e){ var t = e.target.closest && e.target.closest('button,a'); if(t && (!bag || !bag.contains(t))) lastHit = t; }, true);
  document.addEventListener('submit', function(e){ var t = e.submitter || $('[type=submit]', e.target); if(t) lastHit = t; }, true);
  function openBag(){
    if(!bag) return;
    var was = bag.classList.contains('on');
    veil.classList.add('on'); bag.classList.add('on'); bag.setAttribute('aria-hidden','false'); bag.inert = false;
    if(!was){
      var ae = document.activeElement;
      bagBack = lastHit || (ae && ae !== document.body ? ae : null); lastHit = null;
      setTimeout(function(){ var x = $('.cl', bag); try { (x || bag).focus({ preventScroll: true }); } catch(err){ (x || bag).focus(); } }, 40);
    }
  }
  function closeBag(restore){
    if(!bag || !bag.classList.contains('on')) return;
    veil.classList.remove('on'); bag.classList.remove('on'); bag.setAttribute('aria-hidden','true'); bag.inert = true;
    var to = bagBack; bagBack = null;
    if(restore === false) return;
    if(!shown(to)) to = $('[data-mgn-open]'); /* el botón quedó oculto (p. ej. «Ver la bolsa» del menú móvil): a la hamburguesa */
    if(!shown(to)) to = $('.mgn-r .bagbtn') || $('.bagbtn');
    if(to) try { to.focus({ preventScroll: true }); } catch(err){ to.focus(); }
  }
  MG.closeBag = closeBag;
  if(veil) veil.addEventListener('click', function(){ closeBag(); });
  $$('.bag .cl').forEach(function(b){ b.addEventListener('click', function(){ closeBag(); }); });
  document.addEventListener('keydown', function(e){
    if(!bag || !bag.classList.contains('on')) return;
    if(e.key === 'Escape'){ closeBag(); return; }
    if(e.key !== 'Tab') return;
    var f = bagFocusables(); if(!f.length){ e.preventDefault(); bag.focus(); return; }
    var a = f[0], z = f[f.length - 1], ae = document.activeElement;
    if(!bag.contains(ae)){ e.preventDefault(); a.focus(); }
    else if(e.shiftKey && (ae === a || ae === bag)){ e.preventDefault(); z.focus(); }
    else if(!e.shiftKey && ae === z){ e.preventDefault(); a.focus(); }
  });
  /* al volver con «Atrás», el navegador restaura la página tal cual: la bolsa, cerrada */
  window.addEventListener('pageshow', function(e){ if(e.persisted) closeBag(false); });
  $$('.bagbtn').forEach(function(a){ a.addEventListener('click', function(e){ e.preventDefault(); openBag(); }); });

  function nice(t){ t = String(t||'');
    /* tema (13-oct-2026): las piezas con la marca en el nombre («Medias Millo Gang», «MILLO GANG SOCKS») salen sin ella, como en la tarjeta y la ficha */
    if(!/^MILLO GANG DESIGNER %/i.test(t) && /millo gang/i.test(t)){ var x = t.replace(/millo gang/ig,'').replace(/\s+/g,' ').trim(); if(x) t = x; }
    return t.replace(/^MILLO GANG DESIGNER %\s*/i,'').toLowerCase().replace(/ and /g,' & ').replace(/tshirt/g,'tee').replace(/(^|\s)(\S)/g,function(m,a,b){ return a+b.toUpperCase(); }); }
  function noDisc(handle){ return handle === 'millo-coins' || (MG.noDiscount||[]).indexOf(handle) > -1; }
  var COINS_PACKS = {48123361263777:100,48123361296545:500,48123361329313:1000,48123361362081:5000};
  /* tallas como en la ficha: M, no «MEDIUM» */
  var SIZE = { Small: 'S', Medium: 'M', Large: 'L', XLarge: 'XL', XXLarge: 'XXL', 'Pequeño': 'S', 'Mediano': 'M', 'Grande': 'L' };
  var recsTpl = $('#mg-recs'), catsTpl = $('#mg-cats');
  function renderBag(cart){
    $$('.bagn').forEach(function(x){ x.textContent = cart.item_count; });
    /* ficha: la caja del club cambia si la membresía ya está en la bolsa */
    document.documentElement.classList.toggle('mg-hasmem', cart.items.some(function(it){ return it.selling_plan_allocation || it.handle===MG.membershipHandle; }));
    if(!bag) return;
    var bm = $('.bm', bag), items = $('.items', bag), recs = $('.recs', bag), bf = $('.bf', bag);
    var wear = 0, wearOrig = 0, hasMem = false, inCart = {};
    cart.items.forEach(function(it){ inCart[it.handle] = 1; if(it.selling_plan_allocation || it.handle===MG.membershipHandle) hasMem = true; else if(!noDisc(it.handle)){ wear += it.final_line_price; wearOrig += (it.original_line_price || it.final_line_price); } });
    var pct = MG.discount||0, save = Math.round(wear*pct/100);
    /* membresía en la bolsa: el pago ya aplica el 30 % a la ropa (descuento automático de Shopify). Si la bolsa aún no lo trae, se enseña aquí igual */
    var yaRebajada = (cart.total_discount||0) > 0 || cart.items.some(function(it){ return it.final_line_price < it.original_line_price; });
    var rebajar = hasMem && pct && !yaRebajada;
    var total = rebajar ? cart.total_price - save : cart.total_price;
    /* tienda real: si Shopify ya trae la rebaja de miembro, lo que se ahorra es lo que ha bajado la ropa (no el 30 % del precio ya rebajado) */
    if(hasMem && yaRebajada && wearOrig > wear) save = wearOrig - wear;
    var totalOrig = (hasMem && yaRebajada && cart.original_total_price > cart.total_price) ? cart.original_total_price : (rebajar ? cart.total_price : 0);
    /* códigos de descuento (p. ej. /discount/MILLO10): el subtotal sale tachado y una fila dice qué código y cuánto baja (integración 12-oct-2026) */
    if(!totalOrig && !rebajar && cart.original_total_price > cart.total_price) totalOrig = cart.original_total_price;
    var codeRows = (cart.discount_codes||[]).filter(function(d){ return d.applicable; }).map(function(d){
      var amt = 0;
      cart.items.forEach(function(it){ (it.line_level_discount_allocations||[]).forEach(function(a){ if(a.discount_application && a.discount_application.title === d.code) amt += a.amount; }); });
      (cart.cart_level_discount_applications||[]).forEach(function(a){ if(a.title === d.code) amt += a.total_allocated_amount; });
      return amt > 0 ? '<div class="row" style="font-size:12px;letter-spacing:.06em;color:var(--grey)"><span>'+esc(MG.t.code||'Código')+' '+esc(d.code)+'</span><span>−'+esc(money(amt))+'</span></div>' : '';
    }).join('');
    /* la membresía, arriba */
    if(MG.mem && pct && !hasMem){
      /* 14-oct-2026 (Edgar: «esto hazlo mejor»): caja del club en la bolsa con lo que de verdad ahorra
         (solo la ropa lleva el 30 %: si en la bolsa no hay ropa, se dice «30 % en toda la ropa», nunca «en esta bolsa»)
         y un botón limpio («50 €/mes», sin la moneda: data-nocoin).
         29-oct-2026 (Edgar: «lo de miembro más sencillo, no pongas todas las ventajas ni nada»): etiqueta, una línea con la cifra
         y el botón; sin lista de ventajas ni carnet (CSS en sections/mg-header.liquid). */
      var EN_ = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
      var eur = function(c){ var t = money(c); return t.replace(/[,.]00(?=\D*$)/, ''); };
      var fig = wear > 0 ? '−' + esc(eur(save)) : pct + ' %';
      var figL = wear > 0 ? (EN_ ? 'off this cart with the membership' : 'menos en esta cesta con la membresía') : (EN_ ? 'off all clothing, as a member' : 'en toda la ropa, siendo miembro');
      bm.innerHTML = '<div class="memup memup2" data-nocoin><span class="kick">Millo Gantel Club</span>' +
        '<p class="mu-fig"><b>' + fig + '</b> <span>' + esc(figL) + '</span></p>' +
        '<button class="btn w mu-btn" type="button" data-add-membership><span>' + esc(MG.t.memJoinBtn) + ' · ' + esc(eur(MG.mem.price)) + '/' + esc(MG.t.perMonth) + '</span><svg width="16" height="8" viewBox="0 0 16 8" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M0 4h14.5M11 .7 14.5 4 11 7.3"/></svg></button></div>';
    } else if(hasMem && wear>0){
      bm.innerHTML = '<p class="memok">'+esc(MG.t.memIn).replace('{x}','<b>'+esc(money(save))+'</b>')+'</p>';
    } else { bm.innerHTML = ''; }
    /* artículos */
    if(!cart.items.length){
      /* 29-oct-2026 (Edgar: «esto es un caos, lo quiero mucho más limpio»): cesta vacía con el mensaje, un solo botón a toda la tienda
         (el primer enlace de #mg-cats, «Todo») y las demás categorías como enlaces de texto en una fila; en inglés, con los nombres
         de snippets/mg-cat-name.liquid. Sin «Completa el look» (más abajo) */
      var cw = document.createElement('div'); cw.innerHTML = catsTpl ? catsTpl.innerHTML : '';
      var cl = $$('a', cw), todo = cl.shift(), CAT_EN = {sudaderas:'Hoodies', camisetas:'T-Shirts', pantalones:'Bottoms'};
      items.innerHTML = '<div class="empty"><p class="em-t">'+esc(MG.t.empty)+'</p>'+
        (todo ? '<a class="btn em-all" href="'+esc(todo.getAttribute('href'))+'">'+esc(mgThemeEn ? 'Shop all' : 'Ver la tienda')+'</a>' : '')+
        (cl.length ? '<p class="em-cats">'+cl.map(function(a){ var t = a.textContent.trim(); return '<a href="'+esc(a.getAttribute('href'))+'">'+esc(mgThemeEn && CAT_EN[t.toLowerCase()] || t)+'</a>'; }).join('<span aria-hidden="true">·</span>')+'</p>' : '')+'</div>';
    } else {
      items.innerHTML = cart.items.map(function(it){
        var sub = !!it.selling_plan_allocation, isMem = sub || it.handle===MG.membershipHandle;
        var coinsBase = it.handle === 'millo-coins' ? Number(COINS_PACKS[it.variant_id] || 0) * Number(it.quantity || 0) : 0;
        var img = it.featured_image && it.featured_image.url ? String(it.featured_image.url) : '';
        /* la fila del club, como en la web: «Millo Gantel Club», «Cada mes» y su foto (concierto + carnet) */
        if(isMem && MG.memImg) img = MG.memImg;
        if(!isMem && (it.handle==='millo-gang-designer-pink-and-creme-hoodie' || it.handle==='millo-gang-designer-black-tshirt') && it.featured_image && it.featured_image.width && it.featured_image.height){
          var fw = it.featured_image.width, fh = it.featured_image.height;
          var cw = Math.floor(fw*.9), ch = Math.floor(fh*.9);
          img += (img.indexOf('?')>-1?'&':'?')+'crop=region&crop_left='+Math.floor((fw-cw)/2)+'&crop_top='+(fh-ch)+'&crop_width='+cw+'&crop_height='+ch;
        }
        var meta = [];
        if(coinsBase) meta.push(esc(mgThemeEn ? 'Digital · no shipping' : 'Digital · sin envío'));
        if(it.variant_title && it.variant_title!=='Default Title') meta.push(esc(SIZE[it.variant_title] || it.variant_title));
        if(sub){ var pn = it.selling_plan_allocation.selling_plan.name || ''; meta.push(esc(!pn || /^deliver every month$/i.test(pn) ? MG.t.monthly : pn)); }
        if(isMem && MG.discount) meta.push(esc(MG.discount+' % en todo'));
        var qty = sub ? '' : '<span class="qty2"><button type="button" data-q="-1" aria-label="-">&minus;</button><span>'+Number(it.quantity)+'</span><button type="button" data-q="1" aria-label="+">+</button></span>';
        return '<div class="it'+(isMem?' it--mem':'')+(coinsBase?' it--coins':'')+'"'+(coinsBase?' data-millo-base="'+coinsBase+'"':'')+' data-key="'+esc(it.key)+'" data-qty="'+Number(it.quantity)+'">'+(img?'<img src="'+esc(img)+(img.indexOf('?')>-1?'&amp;':'?')+'width=240" alt="" loading="lazy">':'<span></span>')+
          '<div><a class="nm" href="'+esc(it.url)+'">'+esc(isMem && MG.memName ? MG.memName : nice(it.product_title))+'</a><div class="sm">'+meta.join(' · ')+'</div>'+qty+'<button class="rm" type="button">'+esc(MG.t.remove)+'</button></div>'+
          '<div class="p">'+(rebajar && !isMem && !noDisc(it.handle) ? '<s>'+esc(money(it.final_line_price))+'</s>'+esc(money(Math.round(it.final_line_price*(100-pct)/100))) : (it.final_line_price < it.original_line_price ? '<s>'+esc(money(it.original_line_price))+'</s>' : '')+esc(money(it.final_line_price)))+'</div></div>';
      }).join('');
      $$('.it', items).forEach(function(row){
        var k = row.getAttribute('data-key'), q = Number(row.getAttribute('data-qty'));
        $('.rm', row).addEventListener('click', function(){ change(k, 0); });
        $$('[data-q]', row).forEach(function(b){ b.addEventListener('click', function(){ change(k, Math.max(0, q + Number(b.getAttribute('data-q')))); }); });
      });
    }
    /* completa el look: solo con artículos en la cesta (29-oct-2026, Edgar: la cesta vacía, limpia y sin fotos) */
    if(recsTpl && cart.items.length){
      var wrap = document.createElement('div'); wrap.innerHTML = recsTpl.innerHTML;
      /* Precios solo dentro de la ficha: las recomendaciones no son artículos de la bolsa. */
      $$('.rc .rp', wrap).forEach(function(price){ price.remove(); });
      var picks = [].slice.call(wrap.querySelectorAll('.rc')).filter(function(a){ return !inCart[a.getAttribute('data-handle')]; }).slice(0,3);
      recs.innerHTML = picks.length ? '<h4>'+esc(MG.t.recs)+'</h4><div class="rl2">'+picks.map(function(a){ return a.outerHTML; }).join('')+'</div>' : '';
    } else if(recs) recs.innerHTML = '';
    bf.innerHTML = cart.items.length ? codeRows+'<div class="row"><span>'+esc(MG.t.subtotal)+'</span><span>'+(totalOrig ? '<s>'+esc(money(totalOrig))+'</s> ' : '')+esc(money(total))+'</span></div>'+
      '<a class="btn" href="'+esc(R.checkout||'/checkout')+'">'+esc(MG.t.checkout)+' · '+esc(money(total))+'</a><p class="save" style="color:var(--grey);font-size:12px">'+esc(MG.t.shippingNote)+'</p>' : '';
  }
  function getCart(){ return fetch((R.cart||'/cart')+'.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(function(c){ renderBag(c); return c; }); }
  function change(key, q){ return fetch((R.cartChange||'/cart/change')+'.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key, quantity:q})}).then(function(r){ return r.json(); }).then(renderBag); }
  function add(payload){
    return fetch((R.cartAdd||'/cart/add')+'.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(payload)})
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw new Error(j.description||j.message||'Error'); return j; }); })
      .then(function(){ return getCart(); }).then(function(){ openBag(); });
  }
  MG.add = add;
  if(bag) getCart();

  /* añadir la membresía en un clic (bolsa, ficha) */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-add-membership]'); if(!b || !MG.mem) return;
    e.preventDefault(); b.disabled = true;
    var it = {id:Number(MG.mem.variant), quantity:1}; if(MG.mem.plan) it.selling_plan = Number(MG.mem.plan);
    add({items:[it]}).catch(function(err){ alert(err.message); }).then(function(){ b.disabled = false; });
  });

  /* ── compra rápida desde la colección ── */
  document.addEventListener('click', function(e){
    var b = e.target.closest('.qa button[data-v]'); if(!b) return;
    e.preventDefault(); e.stopPropagation(); b.disabled = true;
    add({items:[{id:Number(b.getAttribute('data-v')), quantity:1}]}).catch(function(err){ alert(err.message); }).then(function(){ b.disabled = false; });
  });

  /* vista de la colección: 2, 3 o 4 columnas */
  var grid = $('[data-grid]');
  if(grid){
    var setCols = function(n){ grid.style.setProperty('--cols', n); $$('.view button').forEach(function(x){ x.classList.toggle('on', x.getAttribute('data-cols')===String(n)); }); try{ localStorage.setItem('mg_cols', n); }catch(e){} };
    var saved = null; try{ saved = localStorage.getItem('mg_cols'); }catch(e){}
    if(saved) setCols(saved);
    $$('.view button').forEach(function(b){ b.addEventListener('click', function(){ setCols(b.getAttribute('data-cols')); }); });
  }

  /* ── ficha de producto ── */
  var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* sin talla elegida: aviso «Elige una talla» (role=alert) junto a las tallas y el foco en la primera que queda */
  function askSize(f){
    var sizes = $('.sizes', f), err = $('.err', f.parentNode);
    if(sizes && !calm){ sizes.classList.remove('shake'); void sizes.offsetWidth; sizes.classList.add('shake'); }
    if(err){ err.textContent = ''; err.textContent = MG.t.pickSize || 'Elige una talla'; err.classList.add('on'); }
    var first = sizes && $('button:not(.out)', sizes);
    if(first) try { first.focus({ preventScroll: true }); } catch(x){ first.focus(); }
  }
  $$('form[data-mg-product]').forEach(function(f){
    var btn = $('.add2, .add', f), idIn = $('input[name="id"]', f), sizes = $('.sizes', f), err = $('.err', f.parentNode), nt = $('.notify2', f.parentNode);
    function label(){ return btn ? (btn.getAttribute('data-label')||'') + ' · ' + (btn.getAttribute('data-price')||'') : ''; }
    if(sizes){
      $$('button', sizes).forEach(function(s){
        s.addEventListener('click', function(){
          $$('button', sizes).forEach(function(x){ x.setAttribute('aria-checked', x===s ? 'true' : 'false'); });
          if(err) err.classList.remove('on');
          if(s.classList.contains('out')){
            idIn.value = ''; if(btn){ btn.disabled = true; btn.textContent = MG.t.sizeOut; }
            if(nt){ nt.hidden = false; var ds = $('[data-size]', nt); if(ds) ds.textContent = s.getAttribute('data-name'); }
          } else {
            idIn.value = s.getAttribute('data-v'); if(btn){ btn.disabled = false; btn.textContent = label(); }
            if(nt && !nt.hasAttribute('data-always')) nt.hidden = true;
            try{ history.replaceState(null,'', s.getAttribute('data-url')); }catch(x){}
          }
        });
      });
    }
    f.addEventListener('submit', function(e){
      e.preventDefault();
      if(!idIn || !idIn.value){ askSize(f); return; }
      if(btn) btn.disabled = true;
      var fd = new FormData(f), item = {id:Number(fd.get('id')), quantity:Number(fd.get('quantity')||1)};
      if(fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
      add({items:[item]}).catch(function(x){ if(err){ err.textContent = x.message; err.classList.add('on'); } }).then(function(){ if(btn) btn.disabled = false; });
    });
  });
  $$('.notify2').forEach(function(n){ if(!n.hidden) n.setAttribute('data-always',''); });
  /* miniaturas: llevan a cada foto y marcan la que se ve */
  $$('.pdp2 .thumbs button').forEach(function(b){ b.addEventListener('click', function(){ var t = document.getElementById(b.getAttribute('data-goto')); if(t) t.scrollIntoView({behavior:'smooth', block: window.innerWidth < 980 ? 'nearest' : 'start', inline:'start'}); }); });
  if('IntersectionObserver' in window){
    var tio = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ $$('.pdp2 .thumbs button').forEach(function(b){ b.classList.toggle('on', b.getAttribute('data-goto')===e.target.id); }); } }); }, {threshold:.55});
    $$('.pdp2 .gal .z').forEach(function(z){ tio.observe(z); });
  }
  $$('.sg-open').forEach(function(b){ b.addEventListener('click', function(){ var d = $('details.sg'); if(d){ d.open = true; d.scrollIntoView({behavior:'smooth', block:'center'}); } }); });
  /* barra de compra del móvil: lleva a las tallas y, si no hay ninguna elegida, lo dice */
  $$('[data-scroll-buy]').forEach(function(b){ b.addEventListener('click', function(){
    var f = $('form[data-mg-product]'); if(!f) return;
    f.scrollIntoView({behavior: calm ? 'auto' : 'smooth', block:'center'});
    var idIn = $('input[name="id"]', f);
    if(idIn && !idIn.value) setTimeout(function(){ askSize(f); }, calm ? 0 : 380);
    else if(f.requestSubmit) f.requestSubmit();
  }); });
  /* …y solo se ve cuando el botón principal no está en pantalla */
  var mbar = $('.mbar'), buyF = $('form[data-mg-product]');
  if(mbar && buyF && 'IntersectionObserver' in window){
    new IntersectionObserver(function(es){ es.forEach(function(e){ mbar.classList.toggle('is-hid', e.isIntersecting); }); }, {threshold: 0}).observe(buyF);
  }
  /* zoom en las fotos de la ficha (escritorio) */
  $$('.pdp2 .gal .z, .pdp .gal .z').forEach(function(z){
    var img = $('img', z); if(!img) return;
    z.addEventListener('click', function(){ if(window.innerWidth < 980) return; z.classList.toggle('on'); if(!z.classList.contains('on')) img.style.transformOrigin = ''; });
    z.addEventListener('mousemove', function(e){ if(!z.classList.contains('on')) return; var r = z.getBoundingClientRect(); img.style.transformOrigin = ((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%'; });
    z.addEventListener('mouseleave', function(){ z.classList.remove('on'); });
  });

  /* ── ordenar la colección ── */
  $$('select[data-sort]').forEach(function(s){ s.addEventListener('change', function(){ var u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u.toString(); }); });

  /* ── selector de país y moneda ── */
  $$('.loc select').forEach(function(s){ s.addEventListener('change', function(){ s.form.submit(); }); });

  /* ── pie: tras apuntarse sale el código del 10 % (MILLO10); un toque lo copia ── */
  $$('.ft4-code[data-code]').forEach(function(cb){ cb.addEventListener('click', function(){
    var c = cb.getAttribute('data-code'), i = $('i', cb);
    try{ navigator.clipboard.writeText(c); }catch(e){}
    if(i) i.textContent = i.getAttribute('data-d') || i.textContent;
  }); });

  /* ── ventana del club: 10 % para quien se apunta (Klaviyo si está configurado; si no, Clientes de Shopify) ── */
  var pop = $('.pop3');
  if(pop){
    var P = MG.pop || {}, form = pop.closest('form'), pfine = window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches;
    function ls(k, v){ try{ if(v===undefined) return localStorage.getItem(k); localStorage.setItem(k, v); }catch(e){ return null; } }
    function open(){ if(pop.classList.contains('on') || document.querySelector('.bag.on')) return; pop.classList.add('on'); document.documentElement.classList.add('pop-lock'); var i = $('input[type=email]', pop); if(i && pfine) setTimeout(function(){ i.focus(); }, 350); }
    function close(){ pop.classList.remove('on'); document.documentElement.classList.remove('pop-lock'); if(!pop.classList.contains('is-ok')) ls('mg_pop_snooze', String(Date.now())); }
    function applyCode(){ if(!P.code || MG.demo) return; fetch((R.root || '/') + 'discount/' + encodeURIComponent(P.code), {credentials:'same-origin'}).catch(function(){}); }
    function success(){ pop.classList.add('is-ok'); ls('mg_pop_done','1'); applyCode(); open(); }
    MG.popSuccess = success;
    $$('.x', pop).forEach(function(x){ x.addEventListener('click', close); });
    pop.addEventListener('click', function(e){ if(e.target===pop) close(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && pop.classList.contains('on')) close(); });
    var cp = $('[data-copy]', pop);
    if(cp) cp.addEventListener('click', function(){ var i = $('i', cp); try{ navigator.clipboard.writeText(cp.getAttribute('data-copy')); }catch(e){} if(i){ i.textContent = i.getAttribute('data-d'); setTimeout(function(){ i.textContent = i.getAttribute('data-l'); }, 1600); } });
    if(pop.classList.contains('is-ok')){ ls('mg_pop_done','1'); applyCode(); }
    if(pop.hasAttribute('data-open')) open();
    if(form && P.kKey && P.kList){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var email = ($('input[type=email]', form).value || '').trim(), btn = $('.pop-go', form), err = $('[data-pop-err]', form);
        if(!email) return; if(btn) btn.disabled = true; if(err) err.hidden = true;
        var body = { data: { type: 'subscription', attributes: { custom_source: 'Web · ventana 10 %', profile: { data: { type: 'profile', attributes: { email: email, properties: { popup_code: P.code || '' } } } } }, relationships: { list: { data: { type: 'list', id: P.kList } } } } };
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(P.kKey), { method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(body) })
          .then(function(r){ if(!r.ok) throw new Error(r.status); success(); })
          .catch(function(){ if(err) err.hidden = false; if(btn) btn.disabled = false; });
      });
    }
    var done = ls('mg_pop_done') === '1', snz = Number(ls('mg_pop_snooze') || 0), days = (P.snooze || 7) * 864e5;
    if(!done && !P.skip && !(snz && Date.now() - snz < days) && !pop.hasAttribute('data-open')){
      var fired = false, fire = function(){ if(fired || ls('mg_pop_done') === '1' || pop.classList.contains('is-ok')) return; fired = true; open(); };
      if(MG.popDelay) setTimeout(fire, MG.popDelay*1000);
      window.addEventListener('scroll', function onSc(){ if(window.scrollY > (document.documentElement.scrollHeight - innerHeight) * .5){ window.removeEventListener('scroll', onSc); fire(); } }, {passive:true});
      if(P.exit && pfine) document.addEventListener('mouseout', function(e){ if(!e.relatedTarget && e.clientY < 8) fire(); });
    }
  }


  /* ── membresía: si hay varios planes (mensual, anual, VIP…), elegir uno cambia la variante y el plan del formulario ── */
  $$('[data-plans]').forEach(function(box){
    var f = box.closest('form'), price = document.querySelector('[data-plan-price]');
    function sync(){ var r = $('input:checked', box); if(!r || !f) return; var p = r.value.split(':'); var id = $('input[name=id]', f), sp = $('input[name=selling_plan]', f);
      if(id) id.value = p[0];
      if(p[1]){ if(!sp){ sp = document.createElement('input'); sp.type = 'hidden'; sp.name = 'selling_plan'; f.appendChild(sp); } sp.value = p[1]; } else if(sp){ sp.remove(); }
      if(price && r.getAttribute('data-price')) price.textContent = r.getAttribute('data-price'); }
    box.addEventListener('change', sync); sync();
  });

  /* ── carnet 3D (r3, 12-10-2026): inclinación, giro, nombre y descarga ──
     Delante: filete, chip y emblema «mg». Detrás: banda con «millo gantel club» y nombre · número · miembro desde.
     Si una página aún lleva el marcado antiguo del carnet, aquí se cambia por el nuevo (mismo diseño en todas). */
  var fine = window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches;
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
  var MC_NO = 'MG · 00983';
  function cardNo(s){
    if(!s) return MC_NO;
    var h = 2166136261; for(var i=0;i<s.length;i++){ h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
    return 'MG · ' + ('00000' + (Math.abs(h) % 100000)).slice(-5);
  }
  function yourName(){ return (window.MG && MG.t && MG.t.yourName) || 'Tu nombre'; }
  function mcBuild(card){
    var cd = $('.cd', card); if(!cd || $('.mc-band', cd)) return;
    var sn = $('.since', cd), since = mgThemeEn ? 'Member since 10/26' : 'Miembro desde 10/26';
    if(sn){ var sm = $('small', sn), lbl = sm ? sm.textContent.trim() : '', val = (sn.lastChild && sn.lastChild.textContent || '').trim(); if(lbl && val) since = lbl + ' ' + val; }
    cd.innerHTML = '<div class="face front"><i class="mc-rim"></i><i class="mc-chip"></i><i class="mc-emb"></i><i class="mc-glare"></i></div>'
      + '<div class="face back"><i class="mc-band"><i class="mc-lt"></i></i><i class="mc-rim"></i>'
      + '<div class="mc-row"><span class="mc-name"></span><span class="mc-no"></span><span class="mc-since"></span></div><i class="mc-glare"></i></div>';
    $('.mc-name', cd).textContent = yourName(); $('.mc-no', cd).textContent = MC_NO; $('.mc-since', cd).textContent = since;
  }
  $$('[data-mc3]').forEach(function(card){
    mcBuild(card);
    var cd = $('.cd', card), raf = 0, tx = 0, ty = 0;
    function set(px, py){
      card.style.setProperty('--ry', ((px-.5)*34 - 8)+'deg');
      card.style.setProperty('--rx', (-(py-.5)*24 + 4)+'deg');
      card.style.setProperty('--gx', (px*100)+'%'); card.style.setProperty('--gy', (py*100)+'%');
      card.style.setProperty('--fx', (px*100)+'%'); card.style.setProperty('--fy', (py*100)+'%');
    }
    if(fine && !still){
      card.addEventListener('pointermove', function(e){
        var r = cd.getBoundingClientRect(); tx = Math.min(1, Math.max(0, (e.clientX-r.left)/r.width)); ty = Math.min(1, Math.max(0, (e.clientY-r.top)/r.height));
        card.classList.add('live'); if(!raf) raf = requestAnimationFrame(function(){ raf = 0; set(tx, ty); });
      });
      card.addEventListener('pointerleave', function(){ card.classList.remove('live'); ['--rx','--ry','--gx','--gy','--fx','--fy'].forEach(function(k){ card.style.removeProperty(k); }); });
    } else if(!still && 'DeviceOrientationEvent' in window){
      window.addEventListener('deviceorientation', function(e){ if(e.gamma==null) return; set(Math.min(1,Math.max(0,.5+e.gamma/60)), Math.min(1,Math.max(0,.5+(e.beta-40)/60))); }, {passive:true});
    }
    /* se gira con clic, Intro o Espacio: para los lectores de pantalla es un botón con estado */
    var flip = function(){ var on = card.classList.toggle('flip'); card.setAttribute('aria-pressed', on ? 'true' : 'false'); };
    card.setAttribute('role','button'); card.setAttribute('aria-pressed','false'); card.setAttribute('tabindex','0');
    if(!(mgThemeEn ? /flip/i : /vuelta/i).test(card.getAttribute('aria-label') || '')) card.setAttribute('aria-label', mgThemeEn ? 'Flip the Millo Gantel Club membership card' : 'Dar la vuelta al carnet de miembro del Millo Gantel Club');
    card.addEventListener('click', flip);
    card.addEventListener('keydown', function(e){ if(e.key==='Enter' || e.key===' '){ e.preventDefault(); flip(); } });
  });
  $$('[data-mc-name]').forEach(function(inp){
    var scope = inp.closest('section') || document;
    function upd(){
      var v = (inp.value||'').trim().toUpperCase().slice(0,22);
      $$('.mc-name', scope).forEach(function(el){ el.textContent = v || yourName(); });
      $$('.mc-no', scope).forEach(function(el){ el.textContent = cardNo(v); });
    }
    inp.addEventListener('input', upd); upd();
  });

  /* dibujo del carnet en un lienzo: el mismo diseño que la tarjeta de la web (medidas en % del ancho, como el CSS).
     Las piezas en relieve se leen de las mismas imágenes que pinta el CSS (assets/mg-carnet-*.webp). */
  function mcImgs(scope){
    var probe = $('.mc3', scope) || $('.mc3'), list = ['mc-chip','mc-emb','mc-lt'], out = {}, n = 0;
    return new Promise(function(res){
      list.forEach(function(k){
        var el = probe && $('.' + k, probe), m = el && /url\(\s*["']?([^"')]+)["']?\s*\)/.exec(getComputedStyle(el).backgroundImage), im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = im.onerror = function(){ out[k.slice(3)] = im.naturalWidth ? im : null; if(++n === list.length) res(out); };
        if(m) im.src = m[1]; else im.onerror();
      });
    });
  }
  function mcDraw(x, face, X, Y, w, d, img){
    var h = w/1.586, u = w/100;
    function rrp(p, px, py, pw, ph, r){ p.moveTo(px+r, py); p.arcTo(px+pw, py, px+pw, py+ph, r); p.arcTo(px+pw, py+ph, px, py+ph, r); p.arcTo(px, py+ph, px, py, r); p.arcTo(px, py, px+pw, py, r); p.closePath(); }
    function rr(px, py, pw, ph, r){ x.beginPath(); rrp(x, px, py, pw, ph, r); }
    function lin(x0, y0, x1, y1, st){ var g = x.createLinearGradient(x0, y0, x1, y1); st.forEach(function(s){ g.addColorStop(s[0], s[1]); }); return g; }
    x.save(); x.translate(X, Y);
    rr(0, 0, w, h, 3.75*u);
    if(d.shadow){ x.save(); x.shadowColor = 'rgba(0,0,0,.6)'; x.shadowBlur = 6*u; x.shadowOffsetY = 2.6*u; x.fillStyle = '#060606'; x.fill(); x.restore(); }
    x.save(); x.clip();
    /* degradado elíptico como el radial-gradient del CSS (radios en % del ancho y del alto) */
    function ell(cx, cy, rx, ry, st, op){ x.save(); if(op) x.globalCompositeOperation = op; x.translate(cx, cy); x.scale(rx, ry); var g = x.createRadialGradient(0, 0, 0, 0, 0, 1); st.forEach(function(s){ g.addColorStop(s[0], s[1]); }); x.fillStyle = g; x.fillRect(-cx/rx, -cy/ry, w/rx, h/ry); x.restore(); }
    ell(.22*w, .06*h, 1.3*w, 1.25*h, [[0,'#171615'],[.44,'#0c0c0c'],[1,'#060606']]);
    function piece(im, px, py, pw, sh){ if(!im) return; var ph = pw*im.naturalHeight/im.naturalWidth; x.save(); x.shadowColor = 'rgba(0,0,0,.75)'; x.shadowBlur = sh*u; x.shadowOffsetY = sh*.8*u; x.drawImage(im, px, py, pw, ph); x.restore(); return ph; }
    if(face === 'front'){
      var cw = 11.4*u, ch = img.chip ? cw*img.chip.naturalHeight/img.chip.naturalWidth : cw/1.286;
      piece(img.chip, 7.8*u, h/2 - ch/2, cw, .22);
      if(img.emb){ var ew = 20.5*u, eh = ew*img.emb.naturalHeight/img.emb.naturalWidth; piece(img.emb, w - 6.2*u - ew, h - 5.6*u - eh, ew, .3); }
    } else {
      var by = .127*h, bh = .182*h;
      x.fillStyle = lin(0, 0, w, 0, [[0,'#1f1e1c'],[.45,'#1b1a19'],[1,'#161514']]); x.fillRect(0, by, w, bh);
      x.fillStyle = 'rgba(249,239,223,.16)'; x.fillRect(0, by, w, .16*u); x.fillStyle = 'rgba(249,239,223,.12)'; x.fillRect(0, by + bh - .16*u, w, .16*u);
      if(img.lt){ var lw = 56*u, lh = lw*img.lt.naturalHeight/img.lt.naturalWidth; piece(img.lt, (w - lw)/2, by + (bh - lh)/2, lw, .26); }
      var fs = Math.max(6, 1.85*u), sp = .2*fs, base = h - 5.2*u - fs*.16;
      x.font = '380 ' + fs + 'px Archivo, Helvetica, Arial, sans-serif'; if('fontStretch' in x) x.fontStretch = 'semi-expanded'; if('letterSpacing' in x) x.letterSpacing = sp + 'px';
      x.fillStyle = '#EDE3D3'; x.textBaseline = 'alphabetic';
      var no = (d.no || MC_NO).toUpperCase(), since = (d.since || 'Miembro desde 10/26').toUpperCase(), nm = (d.name || yourName()).toUpperCase();
      var noW = x.measureText(no).width - sp, maxN = (w - 12*u - noW)/2 - 2*u;
      while(nm.length > 1 && x.measureText(nm).width - sp > maxN) nm = nm.slice(0, -2) + '…';
      x.textAlign = 'left'; x.fillText(nm, 6*u, base);
      x.textAlign = 'center'; x.fillText(no, w/2 + sp/2, base);
      x.textAlign = 'right'; x.fillText(since, w - 6*u + sp, base);
    }
    ell(.22*w, .08*h, .85*w, .75*h, [[0,'rgba(255,255,255,.065)'],[.62,'rgba(255,255,255,0)'],[1,'rgba(255,255,255,0)']], 'screen');
    /* filete: anillo de 1 % del ancho en el mismo canto (como el CSS) */
    var o = 0, t = 1*u;
    var ring = new Path2D(); rrp(ring, o, o, w - 2*o, h - 2*o, 3.75*u); rrp(ring, o + t, o + t, w - 2*(o + t), h - 2*(o + t), 3.75*u - t);
    var ang = 118*Math.PI/180, cx0 = w/2 - Math.sin(ang)*w*.6, cy0 = h/2 + Math.cos(ang)*w*.6, cx1 = w/2 + Math.sin(ang)*w*.6, cy1 = h/2 - Math.cos(ang)*w*.6;
    x.fillStyle = lin(cx0, cy0, cx1, cy1, [[0,'#a8866f'],[.13,'#F9EFDF'],[.27,'#DDD4C3'],[.43,'#f8ebdc'],[.57,'#D8CEBE'],[.72,'#F9EFDF'],[.87,'#ae8b74'],[1,'#F9EFDF']]);
    x.fill(ring, 'evenodd');
    x.restore(); x.restore();
    return h;
  }
  /* PNG del carnet: face 'front' | 'back' | 'both' (las dos caras en una imagen 4:5 para compartir) */
  MG.cardPNG = function(face, opt){
    opt = opt || {};
    var scope = opt.scope || document;
    return mcImgs(scope).then(function(img){
      var c = document.createElement('canvas'), x = c.getContext('2d'), d = { name: opt.name, no: opt.no, since: opt.since };
      if(face === 'both'){
        var W = 1600, H = 2000, cw = 1360, ch = cw/1.586, gap = 96, y0 = (H - ch*2 - gap)/2;
        c.width = W; c.height = H; x.fillStyle = '#0e0c0c'; x.fillRect(0, 0, W, H);
        d.shadow = true; mcDraw(x, 'front', (W - cw)/2, y0, cw, d, img); mcDraw(x, 'back', (W - cw)/2, y0 + ch + gap, cw, d, img);
      } else {
        var w = opt.width || 1586; c.width = w; c.height = Math.round(w/1.586); mcDraw(x, face, 0, 0, w, d, img);
      }
      return c.toDataURL('image/png');
    });
  };
  window.MG = window.MG || MG;
  $$('[data-dl]').forEach(function(dl){
    dl.addEventListener('click', function(){
      var scope = dl.closest('section') || document, nmEl = $('.mc-name', scope), noEl = $('.mc-no', scope), snEl = $('.mc-since', scope);
      var opt = { scope: scope, name: nmEl ? nmEl.textContent : '', no: noEl ? noEl.textContent : '', since: snEl ? snEl.textContent : '' };
      var go = function(){ MG.cardPNG('both', opt).then(function(url){
        var a = document.createElement('a'); a.download = 'carnet-millo-gantel-club.png'; a.href = url; document.body.appendChild(a); a.click(); a.remove();
      }); };
      if(document.fonts && document.fonts.load) document.fonts.load('380 20px Archivo').then(go, go); else go();
    });
  });

  /* ── La marca: capítulo activo en el índice ── */
  var idx = $('.br-idx');
  if(idx && 'IntersectionObserver' in window){
    var links = $$('a', idx);
    var io2 = new IntersectionObserver(function(es){ es.forEach(function(e){ if(!e.isIntersecting) return; links.forEach(function(a){ var on = a.getAttribute('href') === '#' + e.target.id; a.classList.toggle('on', on); if(on && idx.scrollTo) idx.scrollTo({left: a.offsetLeft - 20, behavior: 'smooth'}); }); }); }, {rootMargin:'-45% 0px -50% 0px'});
    links.forEach(function(a){ var t = document.getElementById(a.getAttribute('href').slice(1)); if(t) io2.observe(t); });
  }

  /* ── moneda del país, automática ──
     Si el visitante entra desde un país con su propio mercado (p. ej. España → EUR) y la tienda sigue en otro,
     Shopify lo dice en /browsing_context_suggestions.json y lo cambiamos una sola vez por sesión. */
  (function(){
    if(!MG.country || ss('mg_geo') || /[?&](country|currency)=/.test(location.search) || /^\/(cart|checkout|account)/.test(location.pathname)) return;
    ss('mg_geo','1');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(MG.country) + '&language[enabled]=false', {credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        var sug = d && d.suggestions && d.suggestions[0], c = sug && sug.parts && sug.parts.country && sug.parts.country.handle;
        if(!c || c === MG.country || (MG.countries && MG.countries.indexOf(c) < 0)) return;
        var f = document.createElement('form'); f.method = 'post'; f.action = R.localization || '/localization'; f.style.display = 'none';
        [['form_type','localization'],['utf8','✓'],['_method','put'],['return_to', location.pathname + location.search],['country_code', c]].forEach(function(kv){ var i = document.createElement('input'); i.type = 'hidden'; i.name = kv[0]; i.value = kv[1]; f.appendChild(i); });
        document.body.appendChild(f); f.submit();
      }).catch(function(){});
  })();
})();

/* Tarjeta del club en la rejilla (Edgar, 13-oct): a la derecha de la primera fila siempre que se pueda, pero nunca detrás de un agotado.
   Va después de las primeras (columnas − 1) piezas que se pueden comprar o están «Próximamente»; si hay menos, justo detrás de ellas.
   Se recalcula al cambiar el número de columnas (4 en escritorio, 2 en móvil). */
(function(){
  function place(g){
    var club = null, kids = [];
    for (var i = 0; i < g.children.length; i++){
      var k = g.children[i];
      if (k.classList.contains('mtile2')) { club = k; continue; }
      if (k.__mgO === undefined){ k.__mgO = parseInt(getComputedStyle(k).order, 10) || 0; k.__mgI = i; }
      if (getComputedStyle(k).display !== 'none') kids.push(k);
    }
    if (!club) return;
    kids.sort(function(a, b){ return (a.__mgO - b.__mgO) || (a.__mgI - b.__mgI); });
    var cols = getComputedStyle(g).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
    var ok = kids.filter(function(k){ return !k.classList.contains('is-out'); });
    var out = kids.filter(function(k){ return k.classList.contains('is-out'); });
    var n = Math.min(Math.max(cols - 1, 0), ok.length);
    ok.slice(0, n).concat([club], ok.slice(n), out).forEach(function(k, i){ k.style.order = i; });
  }
  function all(){ [].forEach.call(document.querySelectorAll('.grid'), function(g){ if (g.querySelector(':scope > .mtile2')) place(g); }); }
  var t; function later(){ clearTimeout(t); t = setTimeout(all, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  addEventListener('resize', later);
  if (window.MutationObserver) new MutationObserver(function(m){ for (var i = 0; i < m.length; i++) if (m[i].target.classList && m[i].target.classList.contains('grid')) { later(); break; } })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* mg-alinear-cta */
(function(){
  function al(){
    var c = document.querySelector('.ann3 .ann-cta'), r = document.querySelector('.mgn-r'); if (!c || !r) return;
    c.style.minWidth = '';
    if (window.innerWidth < 981) return;
    var L = Infinity; [].forEach.call(r.children, function(k){ var b = k.getBoundingClientRect(); if (b.width > 0 && getComputedStyle(k).display !== 'none') L = Math.min(L, b.left); });
    if (L === Infinity) return;
    var w = Math.round(document.documentElement.clientWidth - L);
    if (w > c.getBoundingClientRect().width) c.style.minWidth = w + 'px';
  }
  var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(al, 120); });
  window.addEventListener('load', al); if (document.fonts && document.fonts.ready) document.fonts.ready.then(al);
  if (document.readyState !== 'loading') al(); else document.addEventListener('DOMContentLoaded', al);
  setTimeout(al, 1500);
})();
